import {
  SupplyType,
  TransmissionSystemOperator,
  VoltageLevel
} from "../../../types/api.types";
import urls from "../../../urls";
import type { FormInputData } from "../../BuildingBlocks/Forms/Controllers/FormFieldController";
import type { ConnectionUpdateRequest } from "../Connection.types";

export const CONNECTION_FORM_FIELD_DATA = {
  name: {
    name: "name",
    label: "Bezeichnung",
    type: "text",
    required: true,
    helpText: "Frei wählbar, wird nur zur Identifikation verwendet"
  },
  voltage: {
    name: "voltage",
    label: "Spannungsebene",
    type: "select",
    required: true,
    data: [
      { label: "Niederspannung", value: VoltageLevel.Low },
      {
        label: "Umspannung zur Niederspannung",
        value: VoltageLevel.MediumTransformation
      },
      { label: "Mittelspannung", value: VoltageLevel.Medium },
      {
        label: "Umspannung zur Mittelspannung",
        value: VoltageLevel.HighTransformation
      },
      { label: "Hochspannung", value: VoltageLevel.High },
      {
        label: "Umspannung zur Hochspannung",
        value: VoltageLevel.ExtraHighTransformation
      },
      { label: "Höchstspannung", value: VoltageLevel.ExtraHigh }
    ]
  },
  grid_operator: {
    name: "grid_operator",
    label: "Anschlussnetzbetreiber",
    type: "async-select",
    required: true,
    helpText: "Betreiber des vorgelagerten Netzes",
    placeholder: "Anschlussnetzbetreiber oder Postleitzahl",
    dataUrl: urls.api.gridOperators()
  },
  transmission_system_operator: {
    name: "transmission_system_operator",
    label: "Übertragungsnetzbetreiber",
    type: "select",
    data: [
      {
        label: "50Hertz Transmission GmbH",
        value: TransmissionSystemOperator.Hertz
      },
      { label: "Amprion GmbH", value: TransmissionSystemOperator.Amprion },
      { label: "TenneT TSO GmbH", value: TransmissionSystemOperator.Tennet },
      { label: "TransnetBW GmbH", value: TransmissionSystemOperator.Transnet }
    ]
  },
  connecting_party: {
    name: "connecting_party",
    label: "Netzanschlussnehmer",
    type: "select",
    helpText:
      "\nDer Netzanschlussnehmer hält den Netzanschlussvertrag mit dem Netzbetreiber.\nIn der Regel ist der Netzanschlussnehmer der Eigentümer der Liegenschaft, die an das Netz der allgemeinen Versorgung angeschlossen ist.\n\nIn Windparks ist in der Regel der Netzanschlussnehmer entweder eine der Anlagenbetreibergesellschaften oder eine Infrastruktur- bzw. Umspannwerksgesellschaft. Diese Angabe finden Sie jedenfalls auf der Fremdbezugsrechnung.\n",
    data: [], // will be set at runtime
    required: true
  },
  supply_contract_held_by: {
    name: "supply_contract_held_by",
    label: "Strombezugsvertrag gehalten durch (Netzanschlussnutzer)",
    type: "select",
    helpText:
      "\nDer Halter des Strombezugsvertrages hat mit dem Lieferanten den Vertrag zur Stromversorgung der Liegenschaft über das öffentliche Netz abgeschlossen. Oftmals sind Netzanschlussnehmer und Halter des Strombezugsvertrages identisch.\n",
    data: [] // will be set at runtime
  },
  supply_type: {
    name: "supply_type",
    label: "Art der Versorgung",
    type: "select",
    data: [
      {
        label: "Teilversorgung (nur PV-Stromlieferung durch Anlagenbetreiber)",
        value: SupplyType.PartialSupply
      },
      {
        label: "Vollversorgung (PV-Strom + Reststromlieferung aus dem Netz)",
        value: SupplyType.FullSupply
      }
    ]
  },
  metering_concept: {
    name: "metering_concept",
    label: "Messkonzept",
    type: "select",
    helpText:
      "\nFür erzeugten, verbrauchten sowie eingespeisten Strom braucht es v.a. \nnach dem Erneuerbare-Energien-Gesetz (EEG) entsprechende Messkonzepte, \num die Energiemengen abzurechnen.\n\n\nDabei spielen Abrechnungsart sowie Vergütungsregeln eine Rolle die \nverschiedene Konzepte erforderlich machen.\nDie Auswahl des Messkonzeptes liegt grundsätzlich beim **Anlagenbetreiber**.\n\n\nDer **Netzbetreiber** hat wiederum die Verpflichtung, das gewählte Messkonzept vor allem\nauf Konformität mit dem EEG, KWKG und den Technischen Anschlussbedingungen zu prüfen\nund freizugeben.\n\n\nAls dritter Aspekt kommt noch der **Messstellenbetreiber** für den Betrieb der Zähler ins Spiel.\n",
    data: [] // will be set at runtime
  }
} as const satisfies {
  [key in keyof ConnectionUpdateRequest]?: FormInputData<
    ConnectionUpdateRequest,
    key
  >;
};
